/* eslint-disable @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires */

export const IllusBerry = require('./Illus-Berry.png');
export const IllusFlower = require('./Illus-Flower.png');
export const IllusSprout = require('./Illus-Sprout.png');
